import httpClient from "./httpClient";

const CommandCenterService = {
  async getStats() {
    return await httpClient.get("/dashboard/command-center");
  }
};

export default CommandCenterService;
